type MediaType = {
    xl: string;
    xlg: string;
    xlgSpecific: string;
    xlgMid: string; // New breakpoint for 1551-1599px
    mdlg: string;
    lg: string;
    lgSpecific: string;
    md: string;
    sm: string;
    xs: string;
    xxs: string; // Extra small screens
};

const Media: MediaType = {
    xl: '@media(max-width:1600px)',
    xlg: '@media(min-width:1350px) and (max-width:1600px)',
    xlgSpecific: '@media(min-width:1600px) and (max-width:1676px)',
    xlgMid: '@media(min-width:1551px) and (max-width:1599px)', // New breakpoint for 1551-1599px
    mdlg: '@media(min-width:1300px) and (max-width:1550px)',
    lg: '@media(max-width:1366px)',
    lgSpecific: '@media(min-width:1367px) and (max-width:1403px)',
    md: '@media(max-width:1024px)',
    sm: '@media(max-width:767px)',
    xs: '@media(max-width:500px)',
    xxs: '@media(max-width:360px)', // Extra small screens
};

export default Media;
